import { formatISO } from 'date-fns';
import { ReactElement } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Calendar as RenderCalendar } from 'modules/crm/Calendar';

export function Calendar(): ReactElement {
  const today = new Date();
  return (
    <Routes>
      <Route path={`:date`} element={<RenderCalendar />} />
      <Route path="*" element={<Navigate to={`${formatISO(today, { representation: 'date' })}`} />} />
    </Routes>
  );
}
